export enum ConditionDataType {
    Bool,
    Text,
    Numeric,
    Date
}
